var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"iconsWrapper",staticClass:"icons",class:_vm.iconsClasses},[_c('div',{ref:"icons"},[_c('v-icon',{ref:"lockIcon",attrs:{"color":"secondary","small":""}},[_vm._v(_vm._s(_vm.lockIconIcon))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }